/* lp-hero.js — the parallax hero's entrance: rule draws → microcap fades → the headline TYPEWRITES
   with a champagne caret → the sub-copy rises. Ported 16 Sep 2026 from the prototype's typeHero()
   (website/Leatherpress_Website_v4_branch2.html, ~line 1873) — same character wrapping, same pace
   (every hero lands in ~1.5s, 20–44ms per character), same 450ms lead-in and 300/900ms tails.
   The prototype replayed on every page change through its hash router; on Shopify every page is a
   real load, so the element types once when it connects, and again when the editor re-mounts or
   selects the section. Reduced-motion visitors see the finished hero at once. */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('lp-hero')) return;

  class LPHero extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.type();
      if (window.Shopify && window.Shopify.designMode) {
        var self = this;
        this._onSelect = function (e) { if (e.target && (e.target === self || e.target.contains(self))) self.type(); };
        document.addEventListener('shopify:section:select', this._onSelect);
      }
    }
    type() {
      var hero = this;
      var copy = hero.querySelector('.pherocopy'); if (!copy) return;
      /* the headline: an <h1>, or a plain element when the microcap is the page's H1 (25 Sep 2026) */
      var h1 = copy.querySelector('.phero-title') || copy.querySelector('h1:not(.microcap)'); if (!h1) return;
      /* cancel any run still in flight for this hero */
      (hero._twTimers || []).forEach(clearTimeout); hero._twTimers = [];
      var sib = h1.nextElementSibling;
      while (sib) { sib.classList.add('psub'); sib = sib.nextElementSibling; }
      var chars = [];
      if (!h1.dataset.wrapped) {
        (function walk(node) {
          [].slice.call(node.childNodes).forEach(function (n) {
            if (n.nodeType === 3) {
              var frag = document.createDocumentFragment();
              n.textContent.split('').forEach(function (c) {
                var s = document.createElement('span'); s.className = 'ch'; s.textContent = c;
                frag.appendChild(s);
              });
              node.replaceChild(frag, n);
            } else { walk(n); }
          });
        })(h1);
        h1.dataset.wrapped = '1';
      }
      /* flat char list (no pauses — the line types straight through, Luke July 21) */
      (function collect(node) {
        [].slice.call(node.childNodes).forEach(function (n) {
          if (n.tagName === 'SPAN' && n.className.indexOf('ch') > -1) chars.push(n);
          else if (n.childNodes) collect(n);
        });
      })(h1);
      /* reset to start state and restart the rule/microcap keyframes */
      chars.forEach(function (c) { c.classList.remove('on', 'cur'); });
      hero.classList.remove('typed', 'phero-anim'); void hero.offsetWidth; hero.classList.add('phero-anim');
      var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (!chars.length || still) {
        chars.forEach(function (c) { c.classList.add('on'); }); hero.classList.add('typed'); return;
      }
      var pace = Math.max(20, Math.min(44, Math.round(1500 / chars.length))); /* quick: every hero lands in ~1.5s */
      var t = 450;
      chars.forEach(function (c, i) {
        (function (el, prev, when) {
          hero._twTimers.push(setTimeout(function () { if (prev) prev.classList.remove('cur'); el.classList.add('on', 'cur'); }, when));
        })(c, chars[i - 1], t);
        t += pace;
      });
      hero._twTimers.push(setTimeout(function () { hero.classList.add('typed'); }, t + 300));
      hero._twTimers.push(setTimeout(function () { chars[chars.length - 1].classList.remove('cur'); }, t + 900));
    }
    disconnectedCallback() {
      (this._twTimers || []).forEach(clearTimeout); this._twTimers = [];
      if (this._onSelect) { document.removeEventListener('shopify:section:select', this._onSelect); this._onSelect = null; }
    }
  }
  customElements.define('lp-hero', LPHero);
})();
